var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-popup',{attrs:{"opened":_vm.opened}},[_c('f7-page',[_c('popup-navigation-bar',{attrs:{"title":"レッスンの流れ | スポともダンス"},on:{"close":function($event){return _vm.$emit("close")}}}),_c('background',[_c('div',{staticClass:"lesson-flow-page"},[_c('iframe',{attrs:{"src":"https://dance-lp.spotomo.com/flow/index.html"}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }